import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get, MICROSERVICES } from 'api';
import { IRemunerationCommission } from 'interfaces/RemunerationCommission';
import {
  IMyKnownError,
  REQUEST_LIFE_CICLE,
  IPaginatedListResponse,
  IListRequestParams,
} from 'interfaces/requests';

import endpoints from './endpoints';
import { IRemunerationCommissionListState } from './interfaces';

export const listRemunerationCommissionAction = createAsyncThunk<
  IPaginatedListResponse<IRemunerationCommission>,
  IListRequestParams,
  { rejectValue: IMyKnownError }
>('listRemunerationCommission/fetch', async (payload, { rejectWithValue }) => {
  try {
    const result = await get<IPaginatedListResponse<IRemunerationCommission>>(
      MICROSERVICES.STRATEGIES,
      {
        url: endpoints.listRemunerationsCommission(),
        params: payload,
      },
    );
    return {
      count: result.data.count,
      values: result.data.values.map((value) => ({ ...value, id: value._id })),
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

const initialState: IRemunerationCommissionListState = {
  loading: REQUEST_LIFE_CICLE.IDLE,
  errorMessage: '',
  list: [],
  count: 0,
};

const remunerationCommissionListSlice = createSlice({
  name: 'remunerationCommissionList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      listRemunerationCommissionAction.fulfilled,
      (state, action) => {
        state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
        state.errorMessage = '';
        state.list = action.payload.values;
        state.count = action.payload.count;
        return state;
      },
    );
    builder.addCase(listRemunerationCommissionAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
      return state;
    });
    builder.addCase(
      listRemunerationCommissionAction.rejected,
      (state, action) => {
        state.loading = REQUEST_LIFE_CICLE.FAILED;
        state.errorMessage = action.payload?.message || '';
        return state;
      },
    );
  },
});

const { reducer } = remunerationCommissionListSlice;
export default reducer;
